export const DEVICE_HISTORY_METHODS = [
  'face_id',
  'mobile_app',
  'pin_code',
  'dtmf',
  'web_browser',
  'delivery_pass',
  'guest_pass',
  'vendor_pass',
] as const;

export type DeviceHistoryMethod = typeof DEVICE_HISTORY_METHODS[number];

export const deviceHistoryMethodLabels: Record<DeviceHistoryMethod, string> = {
  face_id: 'Face ID',
  mobile_app: 'Mobile App',
  pin_code: 'PIN Code',
  dtmf: 'DTMF',
  web_browser: 'Web Browser',
  delivery_pass: 'Delivery Pass',
  guest_pass: 'Guest Pass',
  vendor_pass: 'Vendor Pass',
};

const token = (value?: string | null) => String(value || '').trim().toLowerCase().replace(/[\s.-]+/g, '_');

export const normalizeDeviceHistoryMethod = (methodValue?: string | null, actorTypeValue?: string | null): DeviceHistoryMethod => {
  const method = token(methodValue);
  const actorType = token(actorTypeValue);

  if (actorType === 'delivery') return 'delivery_pass';
  if (actorType === 'vendor') return 'vendor_pass';
  if (actorType === 'guest' || actorType === 'visitor') return 'guest_pass';
  if (['face', 'face_id', 'face_recognition', 'facial_recognition'].includes(method)) return 'face_id';
  if (['app', 'mobile', 'mobile_app', 'ios', 'android'].includes(method)) return 'mobile_app';
  if (['pin', 'pin_code', 'keypad'].includes(method)) return 'pin_code';
  if (['dtmf', 'telephone', 'phone'].includes(method)) return 'dtmf';
  if (['guest_pin', 'visitor_pass', 'guest_pass'].includes(method)) return 'guest_pass';
  if (method === 'delivery_pass') return 'delivery_pass';
  if (method === 'vendor_pass') return 'vendor_pass';
  return 'web_browser';
};

export const deviceHistoryMethodLabel = (method?: string | null, actorType?: string | null): string =>
  deviceHistoryMethodLabels[normalizeDeviceHistoryMethod(method, actorType)];

export const deviceHistoryPhotoRef = (entry: { entry_photo_id?: string | null; guest_pin_id?: string | null }) => entry.entry_photo_id
  ? { key: `pass:${entry.entry_photo_id}`, path: `/visitors/entry-photos/${encodeURIComponent(entry.entry_photo_id)}` }
  : entry.guest_pin_id
    ? { key: `pin:${entry.guest_pin_id}`, path: `/intercom/guest-pin/${encodeURIComponent(entry.guest_pin_id)}/entry-photo` }
    : null;
